import { useContext, useState } from "react"
import VisibilityContext from "src/provider/state-manager/visibilityProvider"
import { AppSpan, AppText, Button, CustomContainer, FlexColumn, FlexRow, GridContainer, Icon } from "src/style"
import MastercardLogo from 'src/assets/img/mastercard-logo.svg'
import { AppCenterPopupD2, CenterPopupHeaderD2, TxPinVerificationD2 } from "src/component"
import {cardActivation} from 'src/utils/mock-data'


export const ActivateCardD2: React.FC<any> = ({close}) => {
    const {notifier} = useContext(VisibilityContext)
    const [isCardDataVisible, setIsCardDataVisible] = useState(false)
    const [view, setView] = useState('activate-card')

    async function handleSubmit() {
        notifier.show('Card Activated', null, 'success')
        close()
    }

    return (
        <>
            { view === 'activate-card' &&
                <AppCenterPopupD2 height='36' zIndex='6' overflow='hidden' close={close}>
                    <CenterPopupHeaderD2 title='Activate Card' close={close} />
                    <CustomContainer 
                        height="36"
                        style={{maxHeight: '77%'}}
                        className="popup-content-container"
                    >
                        <AppSpan>Enter Card Details to activate</AppSpan>
                        <FlexColumn 
                            minHeight="12.7" borderColor="#EAECF0" radius="0.8"
                            padding="2" topPadding="1" bottomPadding="1"
                            justifyContent="space-between" topMargin="2"
                            onClick={() => setIsCardDataVisible(!isCardDataVisible)}
                        >
                            <FlexRow gap="1.5" justifyContent="space-between" alignItems="flex-start">
                                <AppSpan textSize="2" fontWeight="700">{isCardDataVisible ? cardActivation.cardNo : 'XXXX XXXX XXXX XXXX'}</AppSpan>
                                <CustomContainer width='3.46' height='2.4' borderColor="#F2F4F7" radius="0.4">
                                    <Icon src={MastercardLogo} minWidth='100' /> 
                                </CustomContainer>
                            </FlexRow>
                            <FlexRow gap="1.5" justifyContent="space-between" topMargin="1.5">
                                <GridContainer alignItems="start" width="auto" sizeUnit="">
                                    <AppSpan textSize="1" fontWeight="300">MONTH / YEAR</AppSpan>
                                    <AppText textSize="1.6">{isCardDataVisible ? cardActivation.expiryDate : '__/__'}</AppText>
                                </GridContainer>
                                <GridContainer alignItems="end" width="auto" sizeUnit="">
                                    <AppSpan textSize="1" fontWeight="300">CVV</AppSpan>
                                    <AppText textSize="1.6">{isCardDataVisible ? 'XXX' : '___'}</AppText>
                                </GridContainer>
                            </FlexRow>
                        </FlexColumn>
                        <FlexRow topMargin='2.5'>
                            <Button 
                                width='100' sizeUnit="%" height='4.4' 
                                borderColor='#0D968F' hoverBgColor='#fff' 
                                hoverColor='#0D968F' titleSize='1.4'
                                onClick={() => setView('pin')}
                            >
                                Proceed
                            </Button>
                        </FlexRow>
                    </CustomContainer>
                </AppCenterPopupD2>
            }
            { view === 'pin' &&
                <TxPinVerificationD2
                    close={close}
                    next={handleSubmit} 
                />
            }
        </>
    )
}